export default "__VITE_ASSET__jTNli8lh__"